import React, {useEffect, useRef, useState} from 'react';

import {Line} from "../global/Line";

import introImg from "../../images/brand-figure.svg";
import Typed from "typed.js";

export const Intro = (props) => {
  const data = props.data || {};

  const labelRef = useRef(null);

  const [line, setLine] = useState(null);
  const textBlock = useRef(null);

  const typedOptions = {
    showCursor:false,
    typeSpeed: 30,
  };
  let typed = [
    {
      text : data.titlePart1,
      suptext : useRef(null),
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart2,
      suptext : useRef(null),
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart3,
      suptext : useRef(null),
      ref : useRef(null),
      typed : useRef(null)
    }
  ];

  const LineX = () =>{
    return <Line classes="d-none d-md-block" start={typed[2].ref} end={labelRef} color={"#79C600"}  />;
  };
  //Typed
  useEffect(() => {
    let nextWordDelay = 0;
    typed.forEach( (item, index) => {
      if(index !== 0){
        nextWordDelay += typed[index - 1].text.length * typedOptions.typeSpeed;
      }

      item.typed.current = new Typed(item.ref.current, {
        ...typedOptions,
        startDelay : nextWordDelay,
        strings: [
          item.text
        ],
        preStringTyped: (arrayPos, self) => {
          self.el.classList.remove('opacity-0')
          if (item.suptext?.current){
            item.suptext.current.classList.remove('opacity-0')
          }
        },
        onComplete: (self) => {
          if(index === typed.length - 1){
            setLine(<LineX />);

            textBlock.current.classList.remove('opacity-0')
          }
        },
      });
    })
    return () => {
      // Make sure to destroy Typed instance during cleanup
      // to prevent memory leaks
      typed.forEach( (item, index) => {
        item.typed.current.destroy();
      });
    }
  }, []);

  return (
    <section className="pt-14-rem  pb-md-11 pb-lg-18 pb-11 overflow-hidden">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-10 col-lg-12 col-xl-10 position-relative mb-5 mb-md-21 mb-lg-16">
            <h1 className="mb-0 d-inline-flex flex-wrap align-items-start h2 position-relative">
              <span className="zg-text-bg opacity-0 bg-orange mb-1 mb-md-2 me-1 me-md-2" ref={typed[0].ref}></span>
              <span className="zg-label bg-orange me-2 opacity-0" ref={typed[0].suptext}>{data.suptext1}</span>
              <span className="zg-text-bg opacity-0 bg-white mb-1 me-1 me-md-2 mb-md-2" ref={typed[1].ref}></span>
              <span className="zg-text-bg opacity-0 bg-green me-1 me-md-2 mb-1 mb-md-2" ref={typed[2].ref}></span>
              <span className="zg-label bg-green opacity-0" ref={typed[2].suptext}>{data.suptext3}</span>
            </h1>
          </div>
        </div>
        <div className="row align-items-lg-start align-items-md-center opacity-0 transition-opacity" ref={textBlock}>
          <div className="col-12 col-md-6 col-lg-5">
            <img src={introImg} className="d-block ms-md-n5 mt-md-n16 mt-lg-n8 mx-lg-auto mb-8 mb-md-0" alt="Brand" width="408" height="392" loading="lazy"/>
          </div>

          <div className="col-10 offset-2 offset-md-0 col-md-6 col-lg-4 col-xl-3 offset-lg-1 position-relative">
            <span ref={labelRef}
                  className="zg-label bg-green position-absolute end-100 top-0 me-lg-2">{data.number}</span>
            {data.text && (
              <p className="zg-text-lg mb-4 mb-md-5">{data.text}</p>
            )}
            {data.text && (
              <p className="zg-text-sm mb-6 mb-md-8 mb-lg-10">{data.text2}</p>
            )}
            <div className="d-flex flex-column flex-md-row align-items-start">
              {data.link && data.link.url && (
                <a className="btn text-nowrap btn-outline-white btn-outline-white--alt me-3 d-inline-flex align-items-center zg-text-sm" target={data.link.target} rel={data.link.target === '_blank' ? 'noreferrer' : null} href={data.link.url}>
                  {data.link.title}<svg className="ms-1" width="16" height="16"><use xlinkHref="#icon-external"/></svg>
                </a>
              )}
                <a className="btn text-nowrap btn-outline-white mt-3 mt-md-0 btn-outline-white--alt d-inline-flex align-items-center zg-text-sm" target="_blank" rel="noreferrer" href="https://drive.google.com/drive/folders/1IBqsZeIOEhyrdH51noo4sK2c_VPjauzW">
                  Download the files<svg className="ms-1" width="16" height="16"><use xlinkHref="#icon-external"/></svg>
                </a>
            </div>
          </div>
        </div>
        {line}
      </div>
    </section>
  )
}
